// An Idempotency-Key for a request that makes something. It stays the same while the same thing is tried again, so an
// answer lost on the way can't make it twice; it changes once the thing is made, or when what's sent changes.
import { useCallback, useRef } from 'react';

export function useIdempotencyKey(): { keyFor: (body: unknown) => string; made: () => void } {
  const last = useRef<{ body: string; key: string } | null>(null);
  const keyFor = useCallback((body: unknown) => {
    const text = JSON.stringify(body);
    if (last.current?.body !== text) {
      last.current = { body: text, key: crypto.randomUUID() };
    }
    return last.current.key;
  }, []);
  const made = useCallback(() => {
    last.current = null;
  }, []);
  return { keyFor, made };
}
